module.exports = {"id":"dp1_2l1q3","text":"Evaluating Information","instructions":"Is it always easy to tell if online content was created by a human or an AI system?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"PickOne","random":false,"options":[{"id":"dp1_2l1q3-a1","text":"No","score":1.8},{"id":"dp1_2l1q3-a2","text":"Not sure","score":0},{"id":"dp1_2l1q3-a3","text":"Yes","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l1q3.json
// module id = 945
// module chunks = 41